export function PrivacyPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
      <h1 className="mb-6 text-3xl font-bold tracking-tight">Privacy Policy</h1>
      <div className="max-w-none space-y-4 text-muted-foreground leading-relaxed">
        <p className="mb-4">
          This Privacy Policy explains how WingCaster collects, uses, and protects your personal information.
        </p>
        <h2 className="mb-2 mt-6 text-lg font-semibold text-foreground">1. Information We Collect</h2>
        <p className="mb-4">
          We collect information you provide directly, such as name, email, phone number, and professional license details when you register or submit inquiries. We also collect usage data and analytics to improve the platform.
        </p>
        <h2 className="mb-2 mt-6 text-lg font-semibold text-foreground">2. How We Use Your Information</h2>
        <p className="mb-4">
          We use your information to operate the platform, connect users with agents, process inquiries, send notifications, and improve our services. We do not sell your personal information to third parties.
        </p>
        <h2 className="mb-2 mt-6 text-lg font-semibold text-foreground">3. Data Sharing</h2>
        <p className="mb-4">
          Your contact details may be shared with the agent or agency whose listing you inquire about. We may also share data with service providers who help us operate the platform under strict confidentiality.
        </p>
        <h2 className="mb-2 mt-6 text-lg font-semibold text-foreground">4. Security</h2>
        <p className="mb-4">
          We implement reasonable security measures to protect your data. However, no online service is completely secure, and we cannot guarantee absolute security.
        </p>
        <h2 className="mb-2 mt-6 text-lg font-semibold text-foreground">5. Your Rights</h2>
        <p className="mb-4">
          You may access, update, or delete your account information by contacting us. You may also opt out of marketing communications at any time.
        </p>
        <h2 className="mb-2 mt-6 text-lg font-semibold text-foreground">6. Changes to This Policy</h2>
        <p>
          We may update this policy periodically. We encourage you to review it regularly for the latest information about our privacy practices.
        </p>
      </div>
    </div>
  )
}
